export const columnTransformVar = (colId) => `--col-${colId}-transform`;
export const columnWidthVar = (colId) => `--col-${colId.replace(/\./g, "_")}-width`;
export const columnOpacityVar = (colId) => `--col-${colId}-opacity`;
export const columnTransition = () => `--col-transition`;
export const actionsHeaderWidthVar = `--actions-header-width`;
export const displayScrollRightIndicatorVar = `--display-scroll-right-indicator`;
